import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function Transactions() {
  const [txns, setTxns] = useState([]);
  const [tokenActivity, setTokenActivity] = useState({ fills: [], retirements: [] });
  const [filter, setFilter] = useState('');
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  useEffect(() => {
    api.get('/trades/my').then((r) => setTxns(r.data.transactions || [])).catch(() => {});
    api.get('/custody/activity').then((r) => setTokenActivity(r.data)).catch(() => {});
  }, []);

  const filtered = filter ? txns.filter((t) => t.type === filter) : txns;
  const typeColors = { BUY: 'green', SELL_LIST: 'cyan', EPA_SURRENDER: 'orange', SWAP: 'purple', ISSUANCE: 'yellow', DEPOSIT: 'cyan' };

  const loadDetail = async (id) => {
    setDetailLoading(true);
    try {
      const r = await api.get(`/trades/${id}`);
      setDetail(r.data);
    } catch {}
    finally {
      setDetailLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '3rem 2.5rem' }}>
      <div className="section-tag">History</div>
      <h1 className="section-title">TRANSACTION <span style={{ color: 'var(--neon-cyan)' }}>HISTORY</span></h1>

      <div style={{ display: 'flex', gap: '1rem', margin: '1.5rem 0', flexWrap: 'wrap' }}>
        {[['', 'All'], ['BUY', 'Purchases'], ['SELL_LIST', 'Listings'], ['EPA_SURRENDER', 'EPA'], ['SWAP', 'Swaps']].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} style={{ padding: '0.5rem 1.2rem', background: filter === v ? 'rgba(0,229,255,0.1)' : 'transparent', border: `1px solid ${filter === v ? 'var(--neon-cyan)' : 'var(--border)'}`, color: filter === v ? 'var(--neon-cyan)' : 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', letterSpacing: '2px', cursor: 'pointer', textTransform: 'uppercase' }}>
            {l}
          </button>
        ))}
        <div style={{ marginLeft: 'auto', fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>{filtered.length} transactions</div>
      </div>

      <div className="card">
        <table className="data-table">
          <thead>
            <tr><th>Date & Time</th><th>Type</th><th>Credits</th><th>Price</th><th>Amount</th><th>Fee</th><th>Party</th><th>Status</th><th>TX Hash</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: 'center', color: 'var(--muted)', padding: '3rem' }}>No transactions found</td></tr>
            ) : filtered.map((t) => (
              <tr key={t.id}>
                <td style={{ color: 'var(--muted)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>{new Date(t.created_at).toLocaleString('en-IN')}</td>
                <td><span className={`badge badge-${typeColors[t.type] || 'muted'}`}>{t.type?.replace('_', ' ')}</span></td>
                <td style={{ fontFamily: 'Space Mono, monospace' }}>{t.qty?.toLocaleString()} tCO2e</td>
                <td>{t.price ? `Rs.${t.price.toLocaleString()}` : '—'}</td>
                <td style={{ color: t.type === 'BUY' ? 'var(--neon-pink)' : 'var(--neon-green)' }}>
                  {t.total ? `Rs.${t.total.toLocaleString()}` : '—'}
                </td>
                <td style={{ color: 'var(--muted)' }}>{t.fee ? `Rs.${t.fee.toLocaleString()}` : '—'}</td>
                <td style={{ color: 'var(--muted2)', fontSize: '0.7rem' }}>{t.buyer_name || t.seller_name || '—'}</td>
                <td><span className={`badge badge-${t.status === 'settled' || t.status === 'surrendered' ? 'green' : t.status === 'pending' ? 'yellow' : 'muted'}`}>{t.status}</span></td>
                <td style={{ color: 'var(--muted)', fontSize: '0.6rem', fontFamily: 'Space Mono, monospace' }}>
                  <button onClick={() => loadDetail(t.id)} style={{ background: 'transparent', border: 'none', color: 'var(--neon-cyan)', cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: '0.62rem' }}>
                    {t.tx_hash || 'VIEW'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(tokenActivity.fills?.length > 0 || tokenActivity.retirements?.length > 0) && (
        <div className="card" style={{ marginTop: '1rem' }}>
          <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '1rem', letterSpacing: '2px', marginBottom: '1rem' }}>TOKENIZED EXCHANGE ACTIVITY</div>
          <table className="data-table">
            <thead><tr><th>Date</th><th>Type</th><th>Project</th><th>Qty</th><th>Status</th><th>Chain Ref</th></tr></thead>
            <tbody>
              {(tokenActivity.fills || []).map((fill) => (
                <tr key={fill.id}>
                  <td>{new Date(fill.created_at).toLocaleString('en-IN')}</td>
                  <td>FILL</td>
                  <td>{fill.project_name}</td>
                  <td>{Number(fill.quantity).toLocaleString('en-IN')} {fill.symbol}</td>
                  <td>{fill.settlement_status || fill.status}</td>
                  <td style={{ fontSize: '0.65rem' }}>{fill.tx_hash || '—'}</td>
                </tr>
              ))}
              {(tokenActivity.retirements || []).map((item) => (
                <tr key={item.id}>
                  <td>{new Date(item.created_at).toLocaleString('en-IN')}</td>
                  <td>RETIREMENT</td>
                  <td>{item.project_name}</td>
                  <td>{Number(item.quantity).toLocaleString('en-IN')} {item.symbol}</td>
                  <td>{item.status}</td>
                  <td style={{ fontSize: '0.65rem' }}>{item.tx_hash || item.certificate_code}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(detailLoading || detail) && (
        <div className="card" style={{ marginTop: '1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
            <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '1.1rem', letterSpacing: '2px' }}>TRANSACTION DETAIL</div>
            <button onClick={() => setDetail(null)} style={{ border: '1px solid var(--border)', background: 'transparent', color: 'var(--muted)', fontSize: '0.62rem', fontFamily: 'Space Mono, monospace', cursor: 'pointer', padding: '0.2rem 0.5rem' }}>CLOSE</button>
          </div>
          {detailLoading ? (
            <div style={{ color: 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.7rem' }}>Loading detail...</div>
          ) : detail && (
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'Space Mono, monospace', fontSize: '0.68rem', color: 'var(--text)', lineHeight: '1.6' }}>
{JSON.stringify(detail, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}
